import { useState } from "react";

const MOCK_LEADS = [
  {
    id: 1,
    name: "James Whitfield",
    intent: "buy",
    propertyType: "Villa",
    location: "Cascais",
    budget: "€850,000 – €1.2M",
    timeline: "3 months",
    contact: "james.whitfield@gmail.com",
    leadScore: "hot",
    leadScoreReason: "Cash buyer, clear brief, short timeline",
    source: "Idealista",
    assignedTo: "Sofia Martins",
    status: "new",
    receivedAt: "2026-04-13T09:14:00",
    lastContact: null,
    notes: "Looking for sea views, min 4 beds. Already sold UK property.",
    transcript: [
      { role: "assistant", content: "Olá! I'm the LeadQual assistant. How can I help you today?" },
      { role: "user", content: "Hi, I'm looking to buy a villa in Cascais. Budget around 1 million." },
      { role: "assistant", content: "Great choice! Cascais is beautiful. Are you looking for a primary residence or investment property?" },
      { role: "user", content: "Primary residence. We're relocating from the UK. Cash buyer, no chain." },
      { role: "assistant", content: "Wonderful. What's your ideal timeline for the move?" },
      { role: "user", content: "We'd like to be in by summer, so 3 months ideally." },
    ],
  },
  {
    id: 2,
    name: "Mariana Costa",
    intent: "rent",
    propertyType: "Apartment",
    location: "Lisboa - Príncipe Real",
    budget: "€1,500 – €2,000 / month",
    timeline: "1 month",
    contact: "+351 912 345 678",
    leadScore: "warm",
    leadScoreReason: "Good budget, employed, but flexible on area",
    source: "Website",
    assignedTo: "Pedro Alves",
    status: "contacted",
    receivedAt: "2026-04-13T08:02:00",
    lastContact: "2026-04-13T10:30:00",
    notes: "2 people, no pets. Works in tech, remote-friendly.",
    transcript: [
      { role: "assistant", content: "Olá! Em que posso ajudar?" },
      { role: "user", content: "Estou à procura de um apartamento para alugar em Lisboa." },
      { role: "assistant", content: "Claro! Qual é a zona preferida e o orçamento mensal?" },
      { role: "user", content: "Príncipe Real ou Campo de Ourique. Até 2000 euros." },
    ],
  },
  {
    id: 3,
    name: "Heinrich Brandt",
    intent: "buy",
    propertyType: "Apartment",
    location: "Porto - Foz",
    budget: "€400,000 – €550,000",
    timeline: "6–12 months",
    contact: "h.brandt@web.de",
    leadScore: "warm",
    leadScoreReason: "Serious intent but long timeline, needs financing",
    source: "Email (geral@)",
    assignedTo: "Unassigned",
    status: "new",
    receivedAt: "2026-04-12T16:45:00",
    lastContact: null,
    notes: "German buyer, interested in NHR tax regime. Needs mortgage pre-approval.",
    transcript: [
      { role: "assistant", content: "Hello! How can I help you today?" },
      { role: "user", content: "I am interested in buying an apartment in Porto." },
      { role: "assistant", content: "Porto is a fantastic choice! What area are you considering, and what is your budget?" },
      { role: "user", content: "Foz do Douro area. Around 500,000 euros. I will need a mortgage." },
    ],
  },
  {
    id: 4,
    name: "Anonymous",
    intent: "rent",
    propertyType: "Unknown",
    location: "Algarve (vague)",
    budget: "Not specified",
    timeline: "Someday",
    contact: "Not provided",
    leadScore: "cold",
    leadScoreReason: "No budget, no timeline, no contact details",
    source: "Website",
    assignedTo: "Unassigned",
    status: "new",
    receivedAt: "2026-04-12T11:22:00",
    lastContact: null,
    notes: "Just browsing. Asked about general areas.",
    transcript: [
      { role: "assistant", content: "Hello! How can I help you today?" },
      { role: "user", content: "just looking around really" },
      { role: "assistant", content: "No problem! Are you thinking of buying or renting in Portugal?" },
      { role: "user", content: "maybe renting somewhere in the algarve one day" },
    ],
  },
  {
    id: 5,
    name: "Claire Beaumont",
    intent: "buy",
    propertyType: "Townhouse",
    location: "Comporta",
    budget: "€600,000 – €800,000",
    timeline: "2 months",
    contact: "claire.beaumont@outlook.fr",
    leadScore: "hot",
    leadScoreReason: "Decisive, short timeline, clear brief, cash buyer",
    source: "WhatsApp",
    assignedTo: "Sofia Martins",
    status: "viewing",
    receivedAt: "2026-04-11T14:10:00",
    lastContact: "2026-04-12T09:00:00",
    notes: "French buyer. Wants rural feel but close to beach. Viewing booked for Saturday.",
    transcript: [
      { role: "assistant", content: "Hello! How can I help you today?" },
      { role: "user", content: "Hi, I want to buy a house in Comporta. Cash buyer." },
      { role: "assistant", content: "Excellent! Comporta is stunning. What type of property and what's your budget?" },
      { role: "user", content: "Townhouse or cottage. Up to 800k. I want to move in 2 months." },
    ],
  },
];

const AGENTS = ["All Agents", "Sofia Martins", "Pedro Alves", "Unassigned"];
const STATUSES = ["new", "contacted", "viewing", "closed"];

const scoreConfig = {
  hot: { color: "#e05c2a", bg: "rgba(224,92,42,0.12)", label: "HOT" },
  warm: { color: "#c48a1a", bg: "rgba(196,138,26,0.12)", label: "WARM" },
  cold: { color: "#4a7fb5", bg: "rgba(74,127,181,0.12)", label: "COLD" },
};

const sourceIcon = { Idealista: "⬡", "Website": "◉", "Email (geral@)": "✉", WhatsApp: "◎" };
const intentIcon = { buy: "⌂", rent: "◈" };

function timeAgo(dateStr) {
  const diff = (Date.now() - new Date(dateStr)) / 1000 / 60;
  if (diff < 60) return `${Math.floor(diff)}m ago`;
  if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
  return `${Math.floor(diff / 1440)}d ago`;
}

function Avatar({ name, size = 36 }) {
  const initials = name === "Anonymous" ? "?" : name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
  const colors = ["#c9a96e", "#4a90d9", "#5ba85a", "#c0586e", "#8b6fba"];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: color + "22", border: `1.5px solid ${color}44`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.35, fontWeight: 600, color, flexShrink: 0,
      fontFamily: "'DM Sans', sans-serif",
    }}>{initials}</div>
  );
}

function StatusPill({ status, onChange }) {
  const cfg = {
    new: { color: "#4a7fb5", bg: "rgba(74,127,181,0.12)", label: "New" },
    contacted: { color: "#c48a1a", bg: "rgba(196,138,26,0.12)", label: "Contacted" },
    viewing: { color: "#5ba85a", bg: "rgba(91,168,90,0.12)", label: "Viewing" },
    closed: { color: "#888", bg: "rgba(136,136,136,0.12)", label: "Closed" },
  }[status];
  return (
    <select
      value={status}
      onChange={e => onChange(e.target.value)}
      style={{
        background: cfg.bg, color: cfg.color,
        border: `1px solid ${cfg.color}44`,
        borderRadius: "6px", padding: "4px 8px",
        fontSize: "12px", fontWeight: 600, cursor: "pointer",
        fontFamily: "'DM Sans', sans-serif", outline: "none",
      }}
    >
      {STATUSES.map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase() + s.slice(1)}</option>)}
    </select>
  );
}

export default function Dashboard() {
  const [leads, setLeads] = useState(MOCK_LEADS);
  const [selected, setSelected] = useState(null);
  const [filterScore, setFilterScore] = useState("all");
  const [filterAgent, setFilterAgent] = useState("All Agents");
  const [filterStatus, setFilterStatus] = useState("all");
  const [view, setView] = useState("leads"); // leads | rules | settings

  const filtered = leads.filter(l =>
    (filterScore === "all" || l.leadScore === filterScore) &&
    (filterAgent === "All Agents" || l.assignedTo === filterAgent) &&
    (filterStatus === "all" || l.status === filterStatus)
  );

  const hot = leads.filter(l => l.leadScore === "hot").length;
  const warm = leads.filter(l => l.leadScore === "warm").length;
  const cold = leads.filter(l => l.leadScore === "cold").length;
  const uncontacted = leads.filter(l => !l.lastContact).length;

  const updateStatus = (id, status) => {
    setLeads(prev => prev.map(l => l.id === id ? { ...l, status } : l));
    if (selected?.id === id) setSelected(prev => ({ ...prev, status }));
  };

  const selectedLead = selected ? leads.find(l => l.id === selected.id) : null;

  return (
    <div style={s.root}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@300;400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 4px; } 
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 4px; }
        select option { background: #1a2d45; color: #fff; }
      `}</style>

      {/* Sidebar Nav */}
      <div style={s.nav}>
        <div style={s.navLogo}>
          <span style={s.navLogoIcon}>⬡</span>
          <span style={s.navLogoText}>LeadQual</span>
        </div>
        <div style={s.navAgency}>Imobiliária Silva & Associados</div>
        <div style={s.navDivider} />
        {[
          { id: "leads", icon: "◈", label: "Lead Inbox" },
          { id: "rules", icon: "◎", label: "Automation Rules" },
          { id: "settings", icon: "⚙", label: "Settings" },
        ].map(item => (
          <button key={item.id} style={{ ...s.navItem, ...(view === item.id ? s.navItemActive : {}) }}
            onClick={() => { setView(item.id); setSelected(null); }}>
            <span style={s.navIcon}>{item.icon}</span>
            {item.label}
          </button>
        ))}
        <div style={{ flex: 1 }} />
        <div style={s.navUser}>
          <Avatar name="Sofia Martins" size={30} />
          <div>
            <div style={s.navUserName}>Sofia Martins</div>
            <div style={s.navUserRole}>Agency Manager</div>
          </div>
        </div>
      </div>

      {/* Main */}
      <div style={s.main}>
        {view === "leads" && (
          <>
            {/* Stats bar */}
            <div style={s.statsBar}>
              <div style={s.statCard}>
                <div style={s.statNum}>{leads.length}</div>
                <div style={s.statLabel}>Total Leads</div>
              </div>
              <div style={{ ...s.statCard, borderColor: "rgba(224,92,42,0.3)" }}>
                <div style={{ ...s.statNum, color: "#e05c2a" }}>{hot}</div>
                <div style={s.statLabel}>🔥 Hot</div>
              </div>
              <div style={{ ...s.statCard, borderColor: "rgba(196,138,26,0.3)" }}>
                <div style={{ ...s.statNum, color: "#c48a1a" }}>{warm}</div>
                <div style={s.statLabel}>⚡ Warm</div>
              </div>
              <div style={{ ...s.statCard, borderColor: "rgba(74,127,181,0.3)" }}>
                <div style={{ ...s.statNum, color: "#4a7fb5" }}>{cold}</div>
                <div style={s.statLabel}>❄️ Cold</div>
              </div>
              <div style={{ ...s.statCard, borderColor: "rgba(255,100,100,0.3)" }}>
                <div style={{ ...s.statNum, color: "#e05c2a" }}>{uncontacted}</div>
                <div style={s.statLabel}>⚠ Not Contacted</div>
              </div>
            </div>

            <div style={s.content}>
              {/* Lead List */}
              <div style={s.listPanel}>
                {/* Filters */}
                <div style={s.filters}>
                  <select style={s.select} value={filterScore} onChange={e => setFilterScore(e.target.value)}>
                    <option value="all">All Scores</option>
                    <option value="hot">🔥 Hot</option>
                    <option value="warm">⚡ Warm</option>
                    <option value="cold">❄️ Cold</option>
                  </select>
                  <select style={s.select} value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                    <option value="all">All Statuses</option>
                    {STATUSES.map(s2 => <option key={s2} value={s2}>{s2.charAt(0).toUpperCase() + s2.slice(1)}</option>)}
                  </select>
                  <select style={s.select} value={filterAgent} onChange={e => setFilterAgent(e.target.value)}>
                    {AGENTS.map(a => <option key={a} value={a}>{a}</option>)}
                  </select>
                </div>

                {/* Leads */}
                <div style={s.leadList}>
                  {filtered.map(lead => {
                    const sc = scoreConfig[lead.leadScore];
                    const isSelected = selectedLead?.id === lead.id;
                    return (
                      <div key={lead.id} style={{ ...s.leadCard, ...(isSelected ? s.leadCardActive : {}) }}
                        onClick={() => setSelected(lead)}>
                        <div style={s.leadCardTop}>
                          <Avatar name={lead.name} size={38} />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={s.leadName}>{lead.name}</div>
                            <div style={s.leadMeta}>
                              <span>{intentIcon[lead.intent]} {lead.intent === "buy" ? "Buyer" : "Renter"}</span>
                              <span style={s.dot}>·</span>
                              <span>{lead.location}</span>
                            </div>
                          </div>
                          <div style={{ ...s.scoreBadge, background: sc.bg, color: sc.color }}>
                            {sc.label}
                          </div>
                        </div>
                        <div style={s.leadCardBottom}>
                          <span style={s.leadSource}>{sourceIcon[lead.source] || "◉"} {lead.source}</span>
                          <span style={s.leadTime}>{timeAgo(lead.receivedAt)}</span>
                          <StatusPill status={lead.status} onChange={v => updateStatus(lead.id, v)} />
                        </div>
                        {!lead.lastContact && lead.leadScore !== "cold" && (
                          <div style={s.alertBanner}>⚠ Not yet contacted</div>
                        )}
                      </div>
                    );
                  })}
                  {filtered.length === 0 && (
                    <div style={s.empty}>No leads match your filters</div>
                  )}
                </div>
              </div>

              {/* Detail Panel */}
              <div style={s.detailPanel}>
                {!selectedLead ? (
                  <div style={s.detailEmpty}>
                    <div style={s.detailEmptyIcon}>◈</div>
                    <p style={s.detailEmptyText}>Select a lead to view details</p>
                  </div>
                ) : (
                  <div style={s.detailInner}>
                    {/* Header */}
                    <div style={s.detailHeader}>
                      <Avatar name={selectedLead.name} size={48} />
                      <div style={{ flex: 1 }}>
                        <div style={s.detailName}>{selectedLead.name}</div>
                        <div style={s.detailSub}>{selectedLead.contact}</div>
                      </div>
                      <div style={{
                        ...s.scoreBadgeLg,
                        background: scoreConfig[selectedLead.leadScore].bg,
                        color: scoreConfig[selectedLead.leadScore].color,
                        border: `1px solid ${scoreConfig[selectedLead.leadScore].color}44`,
                      }}>
                        {selectedLead.leadScore === "hot" ? "🔥" : selectedLead.leadScore === "warm" ? "⚡" : "❄️"} {scoreConfig[selectedLead.leadScore].label}
                      </div>
                    </div>

                    {/* Key facts grid */}
                    <div style={s.factsGrid}>
                      {[
                        ["Intent", selectedLead.intent === "buy" ? "⌂ Buy" : "◈ Rent"],
                        ["Property", selectedLead.propertyType],
                        ["Location", selectedLead.location],
                        ["Budget", selectedLead.budget],
                        ["Timeline", selectedLead.timeline],
                        ["Source", selectedLead.source],
                        ["Assigned to", selectedLead.assignedTo],
                        ["Received", timeAgo(selectedLead.receivedAt)],
                      ].map(([label, val]) => (
                        <div key={label} style={s.factItem}>
                          <div style={s.factLabel}>{label}</div>
                          <div style={s.factVal}>{val}</div>
                        </div>
                      ))}
                    </div>

                    {/* Score reason */}
                    <div style={s.scoreReason}>
                      <div style={s.sectionLabel}>AI Assessment</div>
                      <p style={s.scoreReasonText}>{selectedLead.leadScoreReason}</p>
                    </div>

                    {/* Notes */}
                    {selectedLead.notes && (
                      <div style={s.notesBox}>
                        <div style={s.sectionLabel}>Notes</div>
                        <p style={s.notesText}>{selectedLead.notes}</p>
                      </div>
                    )}

                    {/* Status update */}
                    <div style={s.statusRow}>
                      <div style={s.sectionLabel}>Status</div>
                      <StatusPill status={selectedLead.status} onChange={v => updateStatus(selectedLead.id, v)} />
                    </div>

                    {/* Transcript */}
                    <div>
                      <div style={s.sectionLabel}>AI Conversation Transcript</div>
                      <div style={s.transcript}>
                        {selectedLead.transcript.map((msg, i) => (
                          <div key={i} style={msg.role === "user" ? s.txUser : s.txBot}>
                            <div style={msg.role === "user" ? s.txUserBubble : s.txBotBubble}>
                              {msg.content}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Actions */}
                    <div style={s.actions}>
                      <button style={s.actionBtn}>✉ Send Email</button>
                      <button style={s.actionBtn}>◎ WhatsApp</button>
                      <button style={{ ...s.actionBtn, ...s.actionBtnPrimary }}>⌂ Book Viewing</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {view === "rules" && <RulesView />}
        {view === "settings" && <SettingsView />}
      </div>
    </div>
  );
}

function RulesView() {
  const [rules, setRules] = useState([
    { id: 1, active: true, trigger: "Hot lead not contacted", delay: "2", action: "WhatsApp alert to manager", score: "hot" },
    { id: 2, active: true, trigger: "Any lead not contacted", delay: "24", action: "Email reminder to assigned agent", score: "all" },
    { id: 3, active: false, trigger: "Warm lead not contacted", delay: "48", action: "Escalate to manager", score: "warm" },
  ]);

  return (
    <div style={s.pageInner}>
      <div style={s.pageHeader}>
        <div>
          <h2 style={s.pageTitle}>Automation Rules</h2>
          <p style={s.pageSubtitle}>Set automatic follow-up reminders and escalations</p>
        </div>
        <button style={{ ...s.actionBtn, ...s.actionBtnPrimary }}>+ New Rule</button>
      </div>

      <div style={s.rulesList}>
        {rules.map(rule => (
          <div key={rule.id} style={s.ruleCard}>
            <div style={s.ruleLeft}>
              <div style={{
                ...s.ruleToggle,
                background: rule.active ? "rgba(91,168,90,0.2)" : "rgba(136,136,136,0.15)",
                borderColor: rule.active ? "rgba(91,168,90,0.4)" : "rgba(136,136,136,0.3)",
              }} onClick={() => setRules(prev => prev.map(r => r.id === rule.id ? { ...r, active: !r.active } : r))}>
                <div style={{ ...s.ruleToggleDot, transform: rule.active ? "translateX(16px)" : "translateX(0)", background: rule.active ? "#5ba85a" : "#888" }} />
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={s.ruleName}>
                If a <strong style={{ color: rule.score === "hot" ? "#e05c2a" : rule.score === "warm" ? "#c48a1a" : "#ccc" }}>
                  {rule.score === "all" ? "any" : rule.score}
                </strong> lead is not contacted within <strong style={{ color: "#c9a96e" }}>{rule.delay} hours</strong>
              </div>
              <div style={s.ruleAction}>→ {rule.action}</div>
            </div>
            <div style={s.ruleStatus}>
              <span style={{ color: rule.active ? "#5ba85a" : "#666", fontSize: "12px" }}>
                {rule.active ? "Active" : "Paused"}
              </span>
            </div>
          </div>
        ))}
      </div>

      <div style={s.rulesInfo}>
        <div style={s.rulesInfoIcon}>◎</div>
        <p style={s.rulesInfoText}>Rules run automatically every 15 minutes. WhatsApp alerts require WhatsApp Business integration to be enabled in Settings.</p>
      </div>
    </div>
  );
}

function SettingsView() {
  return (
    <div style={s.pageInner}>
      <div style={s.pageHeader}>
        <div>
          <h2 style={s.pageTitle}>Agency Settings</h2>
          <p style={s.pageSubtitle}>Configure your LeadQual integration</p>
        </div>
      </div>

      <div style={s.settingsGrid}>
        {[
          { label: "Agency Name", value: "Imobiliária Silva & Associados", type: "text" },
          { label: "Primary Email (geral@)", value: "geral@silvaassociados.pt", type: "email" },
          { label: "WhatsApp Business Number", value: "+351 910 000 000", type: "tel" },
          { label: "Default Language", value: "Auto-detect (PT / EN)", type: "select" },
        ].map(field => (
          <div key={field.label} style={s.settingsField}>
            <label style={s.settingsLabel}>{field.label}</label>
            <input style={s.settingsInput} defaultValue={field.value} type={field.type} />
          </div>
        ))}
      </div>

      <div style={s.integrations}>
        <div style={s.sectionLabel}>Integrations</div>
        {[
          { name: "Website Chat Widget", status: "connected", color: "#5ba85a" },
          { name: "Email (geral@)", status: "not connected", color: "#e05c2a" },
          { name: "WhatsApp Business", status: "not connected", color: "#e05c2a" },
          { name: "Idealista (via email)", status: "connected", color: "#5ba85a" },
        ].map(item => (
          <div key={item.name} style={s.integrationRow}>
            <span style={s.integrationName}>{item.name}</span>
            <span style={{ ...s.integrationStatus, color: item.color }}>{item.status}</span>
            <button style={s.integrationBtn}>{item.status === "connected" ? "Manage" : "Connect →"}</button>
          </div>
        ))}
      </div>

      <button style={{ ...s.actionBtn, ...s.actionBtnPrimary, marginTop: "24px" }}>Save Changes</button>
    </div>
  );
}

const s = {
  root: {
    display: "flex", height: "100vh", fontFamily: "'DM Sans', sans-serif",
    background: "#0d1926", color: "#fff", overflow: "hidden",
  },
  nav: {
    width: "220px", minWidth: "220px", background: "#09111e",
    borderRight: "1px solid rgba(255,255,255,0.06)",
    display: "flex", flexDirection: "column", padding: "20px 12px",
  },
  navLogo: { display: "flex", alignItems: "center", gap: "8px", padding: "0 8px 4px" },
  navLogoIcon: { fontSize: "22px", color: "#c9a96e", fontFamily: "'DM Serif Display', serif" },
  navLogoText: { fontFamily: "'DM Serif Display', serif", fontSize: "18px", color: "#fff" },
  navAgency: { fontSize: "10px", color: "rgba(255,255,255,0.3)", padding: "0 8px 16px", lineHeight: 1.4 },
  navDivider: { height: "1px", background: "rgba(255,255,255,0.06)", margin: "0 0 12px" },
  navItem: {
    display: "flex", alignItems: "center", gap: "10px",
    padding: "10px 12px", borderRadius: "8px",
    background: "none", border: "none", color: "rgba(255,255,255,0.5)",
    fontSize: "13px", fontWeight: 500, cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif", width: "100%", textAlign: "left",
    marginBottom: "2px", transition: "all 0.15s",
  },
  navItemActive: { background: "rgba(201,169,110,0.1)", color: "#c9a96e" },
  navIcon: { fontSize: "14px", width: "16px", textAlign: "center" },
  navUser: {
    display: "flex", alignItems: "center", gap: "10px",
    padding: "12px", borderTop: "1px solid rgba(255,255,255,0.06)",
    marginTop: "8px",
  },
  navUserName: { fontSize: "12px", fontWeight: 600, color: "rgba(255,255,255,0.8)" },
  navUserRole: { fontSize: "11px", color: "rgba(255,255,255,0.35)" },

  main: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" },

  statsBar: {
    display: "flex", gap: "12px", padding: "16px 20px",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    background: "#0b1520",
  },
  statCard: {
    flex: 1, padding: "12px 16px", borderRadius: "10px",
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
  },
  statNum: { fontSize: "24px", fontWeight: 600, color: "#fff", lineHeight: 1 },
  statLabel: { fontSize: "11px", color: "rgba(255,255,255,0.4)", marginTop: "4px" },

  content: { display: "flex", flex: 1, overflow: "hidden" },

  listPanel: {
    width: "360px", minWidth: "360px",
    borderRight: "1px solid rgba(255,255,255,0.06)",
    display: "flex", flexDirection: "column", overflow: "hidden",
  },
  filters: {
    display: "flex", gap: "6px", padding: "12px",
    borderBottom: "1px solid rgba(255,255,255,0.06)",
  },
  select: {
    flex: 1, background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)", borderRadius: "7px",
    color: "rgba(255,255,255,0.7)", fontSize: "11px", padding: "6px 8px",
    fontFamily: "'DM Sans', sans-serif", outline: "none", cursor: "pointer",
  },
  leadList: { flex: 1, overflowY: "auto", padding: "8px" },
  leadCard: {
    padding: "14px", borderRadius: "10px", marginBottom: "6px",
    background: "rgba(255,255,255,0.03)",
    border: "1px solid rgba(255,255,255,0.07)",
    cursor: "pointer", transition: "all 0.15s",
  },
  leadCardActive: {
    background: "rgba(201,169,110,0.08)",
    border: "1px solid rgba(201,169,110,0.25)",
  },
  leadCardTop: { display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" },
  leadName: { fontSize: "14px", fontWeight: 600, color: "#fff" },
  leadMeta: { fontSize: "12px", color: "rgba(255,255,255,0.4)", marginTop: "2px" },
  dot: { margin: "0 4px" },
  scoreBadge: {
    fontSize: "10px", fontWeight: 700, padding: "3px 8px",
    borderRadius: "5px", letterSpacing: "0.5px", flexShrink: 0,
  },
  leadCardBottom: { display: "flex", alignItems: "center", gap: "8px" },
  leadSource: { fontSize: "11px", color: "rgba(255,255,255,0.35)", flex: 1 },
  leadTime: { fontSize: "11px", color: "rgba(255,255,255,0.25)" },
  alertBanner: {
    marginTop: "8px", fontSize: "11px", color: "#e05c2a",
    background: "rgba(224,92,42,0.08)", borderRadius: "5px",
    padding: "4px 8px", border: "1px solid rgba(224,92,42,0.2)",
  },
  empty: { textAlign: "center", color: "rgba(255,255,255,0.2)", padding: "40px 20px", fontSize: "13px" },

  detailPanel: { flex: 1, overflowY: "auto" },
  detailEmpty: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: "12px" },
  detailEmptyIcon: { fontSize: "40px", color: "rgba(255,255,255,0.1)" },
  detailEmptyText: { color: "rgba(255,255,255,0.2)", fontSize: "14px" },
  detailInner: { padding: "24px" },
  detailHeader: { display: "flex", alignItems: "center", gap: "14px", marginBottom: "20px" },
  detailName: { fontSize: "20px", fontWeight: 600, color: "#fff", fontFamily: "'DM Serif Display', serif" },
  detailSub: { fontSize: "13px", color: "rgba(255,255,255,0.4)", marginTop: "2px" },
  scoreBadgeLg: { fontSize: "13px", fontWeight: 700, padding: "6px 14px", borderRadius: "8px", letterSpacing: "0.5px" },

  factsGrid: {
    display: "grid", gridTemplateColumns: "1fr 1fr",
    gap: "10px", marginBottom: "20px",
  },
  factItem: {
    background: "rgba(255,255,255,0.04)", borderRadius: "8px",
    padding: "10px 12px", border: "1px solid rgba(255,255,255,0.07)",
  },
  factLabel: { fontSize: "10px", color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "3px" },
  factVal: { fontSize: "13px", color: "rgba(255,255,255,0.85)", fontWeight: 500 },

  sectionLabel: { fontSize: "10px", color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "8px" },

  scoreReason: {
    background: "rgba(255,255,255,0.04)", borderRadius: "8px",
    padding: "12px", marginBottom: "14px", border: "1px solid rgba(255,255,255,0.07)",
  },
  scoreReasonText: { fontSize: "13px", color: "rgba(255,255,255,0.7)", lineHeight: 1.5 },

  notesBox: {
    background: "rgba(201,169,110,0.06)", borderRadius: "8px",
    padding: "12px", marginBottom: "14px", border: "1px solid rgba(201,169,110,0.15)",
  },
  notesText: { fontSize: "13px", color: "rgba(255,255,255,0.7)", lineHeight: 1.5 },

  statusRow: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" },

  transcript: {
    background: "rgba(0,0,0,0.2)", borderRadius: "10px",
    padding: "14px", display: "flex", flexDirection: "column",
    gap: "8px", marginBottom: "16px", maxHeight: "200px", overflowY: "auto",
    border: "1px solid rgba(255,255,255,0.06)",
  },
  txBot: { display: "flex" },
  txUser: { display: "flex", justifyContent: "flex-end" },
  txBotBubble: {
    background: "rgba(255,255,255,0.07)", borderRadius: "4px 10px 10px 10px",
    padding: "8px 12px", fontSize: "12px", color: "rgba(255,255,255,0.75)",
    maxWidth: "80%", lineHeight: 1.5,
  },
  txUserBubble: {
    background: "rgba(201,169,110,0.2)", borderRadius: "10px 10px 4px 10px",
    padding: "8px 12px", fontSize: "12px", color: "rgba(255,255,255,0.85)",
    maxWidth: "80%", lineHeight: 1.5,
  },

  actions: { display: "flex", gap: "8px", flexWrap: "wrap" },
  actionBtn: {
    padding: "9px 16px", borderRadius: "8px", fontSize: "13px",
    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)",
    color: "rgba(255,255,255,0.8)", cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif", fontWeight: 500,
  },
  actionBtnPrimary: {
    background: "rgba(201,169,110,0.15)", border: "1px solid rgba(201,169,110,0.35)",
    color: "#c9a96e",
  },

  // Rules
  pageInner: { padding: "28px", overflowY: "auto", flex: 1 },
  pageHeader: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "28px" },
  pageTitle: { fontSize: "22px", fontWeight: 600, color: "#fff", fontFamily: "'DM Serif Display', serif", marginBottom: "4px" },
  pageSubtitle: { fontSize: "13px", color: "rgba(255,255,255,0.4)" },
  rulesList: { display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px" },
  ruleCard: {
    display: "flex", alignItems: "center", gap: "16px",
    background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "10px", padding: "16px",
  },
  ruleLeft: { flexShrink: 0 },
  ruleToggle: {
    width: "36px", height: "20px", borderRadius: "10px", border: "1px solid",
    cursor: "pointer", position: "relative", transition: "all 0.2s",
  },
  ruleToggleDot: {
    position: "absolute", top: "2px", left: "2px",
    width: "14px", height: "14px", borderRadius: "50%",
    transition: "all 0.2s",
  },
  ruleName: { fontSize: "14px", color: "rgba(255,255,255,0.8)", marginBottom: "4px", lineHeight: 1.5 },
  ruleAction: { fontSize: "12px", color: "rgba(255,255,255,0.4)" },
  ruleStatus: { flexShrink: 0 },
  rulesInfo: {
    display: "flex", gap: "12px", alignItems: "flex-start",
    background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)",
    borderRadius: "10px", padding: "16px",
  },
  rulesInfoIcon: { fontSize: "20px", color: "rgba(255,255,255,0.2)", flexShrink: 0 },
  rulesInfoText: { fontSize: "13px", color: "rgba(255,255,255,0.35)", lineHeight: 1.6 },

  // Settings
  settingsGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "28px" },
  settingsField: { display: "flex", flexDirection: "column", gap: "6px" },
  settingsLabel: { fontSize: "11px", color: "rgba(255,255,255,0.4)", textTransform: "uppercase", letterSpacing: "1px" },
  settingsInput: {
    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "8px", padding: "10px 12px", color: "#fff",
    fontSize: "13px", fontFamily: "'DM Sans', sans-serif", outline: "none",
  },
  integrations: { marginBottom: "8px" },
  integrationRow: {
    display: "flex", alignItems: "center", gap: "12px",
    padding: "12px 0", borderBottom: "1px solid rgba(255,255,255,0.06)",
  },
  integrationName: { flex: 1, fontSize: "14px", color: "rgba(255,255,255,0.75)" },
  integrationStatus: { fontSize: "12px", fontWeight: 500 },
  integrationBtn: {
    padding: "6px 12px", borderRadius: "6px", fontSize: "12px",
    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
    color: "rgba(255,255,255,0.6)", cursor: "pointer",
    fontFamily: "'DM Sans', sans-serif",
  },
};
